<template>
  <f7-page class="page-secret-question">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Trở lại"></f7-nav-left>
      <f7-nav-title sliding>CÂU HỎI BẢO MẬT</f7-nav-title>
    </f7-navbar>
    <f7-row v-if="_.isEmpty(user_info.telegram)">
      <f7-col>
        <f7-card>
          <f7-card-content>
            <p>Vui lòng liên kết Telegram trước</p>
          </f7-card-content>
          <f7-card-footer>
            <f7-link @click="$f7router.navigate('/tao-ma-gioi-thieu')">Liên kết ngay</f7-link>
          </f7-card-footer>
        </f7-card>
      </f7-col>
    </f7-row>
    <template v-else>
      <f7-list inset>
        <f7-list-input
            type="select"
            placeholder="Câu hỏi bảo mật 1"
            :value="form_secret.secret_question_1"
            @input="form_secret.secret_question_1 = $event.target.value"
        >
          <f7-icon ios="f7:question_square" slot="media"></f7-icon>
          <option :value="item" v-for="(item, idx) in questions" :key="idx">{{ item }}</option>
        </f7-list-input>
        <f7-list-input
            type="text"
            placeholder="Trả lời"
            :value="form_secret.answer_secret_question_1"
            @input="form_secret.answer_secret_question_1 = $event.target.value"
        >
          <f7-icon ios="f7:quote_bubble" slot="media"></f7-icon>
        </f7-list-input>
        <f7-list-input
            type="select"
            placeholder="Câu hỏi bảo mật 1"
            :value="form_secret.secret_question_2"
            @input="form_secret.secret_question_2 = $event.target.value"
        >
          <f7-icon ios="f7:question_square" slot="media"></f7-icon>
          <option :value="item" v-for="(item, idx) in questions" :key="idx">{{ item }}</option>
        </f7-list-input>
        <f7-list-input
            type="text"
            placeholder="Trả lời"
            :value="form_secret.answer_secret_question_2"
            @input="form_secret.answer_secret_question_2 = $event.target.value"
        >
          <f7-icon ios="f7:quote_bubble" slot="media"></f7-icon>
        </f7-list-input>
        <f7-list-input
            label="Mã OTP"
            placeholder="Mã OTP"
            type="text"
            :value="form_secret.otp"
            @input="form_secret.otp = $event.target.value"
        >
          <f7-icon ios="f7:qrcode" slot="media"></f7-icon>
          <template slot="content-end">
            <f7-button class="button-otp" outline @click.prevent="generateOTP">Lấy mã</f7-button>
          </template>
        </f7-list-input>
      </f7-list>
      <f7-block inset>
        <f7-button fill color="primary" @click.prevent="submitFormChangeSecret">
          LƯU THÔNG TIN
        </f7-button>
      </f7-block>
    </template>
  </f7-page>
</template>
<style scoped>
.button-otp {
  width : 110px;
}
</style>
<script>
import {mapState} from 'vuex';

export default {
  data(){
    return {
      questions  :[
        'Biệt danh lúc nhỏ của bạn',
        'Tên đội thể thao yêu thích của bạn',
        '6 số cuối trong CMND/Passport',
        'Tên chú chó đầu tiên bạn nuôi',
        'Tên trường tiểu học mà bạn đã học',
        'Bạn thân của bạn thời thiếu niên',
        'Món ăn mà bạn thích nhất',
        'Bài hát yêu thích của bạn',
        'Người thầy đầu tiên của bạn',
        'Địa điểm mà bạn thích đến nhất'
      ],
      form_secret:{
        secret_question_1       :'',
        answer_secret_question_1:'',
        secret_question_2       :'',
        answer_secret_question_2:'',
        otp                     :''
      }
    }
  },
  computed:{
    ...mapState(['user_info'])
  },
  methods :{
    submitFormChangeSecret(){
      if(this.form_secret.secret_question_1 === this.form_secret.secret_question_2){
        this.$f7.dialog.alert('Vui lòng chọn 2 câu hỏi khác nhau', 'LỖI');
        return false;
      }

      if(this.form_secret.answer_secret_question_1 === '' || this.form_secret.answer_secret_question_2 === ''){
        this.$f7.dialog.alert('Vui lòng nhập câu trả lời', 'LỖI');
        return false;
      }

      this.$f7.preloader.show();

      this.$store.dispatch('updateUserInfo', this.form_secret)
          .then(() => {
            this.$f7.preloader.hide();
            this.$f7.dialog.alert('Đã cập nhật thông tin', 'THÔNG BÁO');
          })
          .catch((error) => {
            this.$f7.preloader.hide();
            this.$f7.dialog.alert(error, 'LỖI');
          });
    },
    generateOTP(){
      this.$f7.dialog.preloader();

      this.$store.dispatch('generateOtpUpdateInfo').then(() => {
        this.$f7.dialog.close();
      }).catch((err) => {
        this.$f7.dialog.close();
        this.$f7.dialog.alert(err, 'LỖI!');
      });
    }
  },
  mounted(){
    this.form_secret.secret_question_1 = this._.isEmpty(this.user_info.secret_question_1) ? this.questions[0] : this.user_info.secret_question_1;
    this.form_secret.secret_question_2 = this._.isEmpty(this.user_info.secret_question_2) ? this.questions[0] : this.user_info.secret_question_2;
  }
};
</script>
